module.exports = __webpack_public_path__ + "img/141ne.fa468cea.svg";